import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="cv-auto py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-111">
      <div className="max-w-4xl mx-auto" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="bg-gradient-to-b from-navy-800 to-navy-950 rounded-[2.5rem] p-8 md:p-14 text-center relative overflow-hidden" data-id="element-113">
          <div className="relative z-10" data-id="element-114">
            <ShieldCheck className="w-16 h-16 md:w-20 md:h-20 text-blue-400 mx-auto mb-8" data-id="element-115" />

            <h2 className="text-3xl md:text-5xl font-extrabold italic mb-8 text-white" data-id="element-116">
              GARANTÍA TOTAL DE 7 DÍAS
            </h2>

            <p className="text-lg md:text-xl text-slate-300 mb-3" data-id="element-117">
              Probalo durante 7 días completos.
            </p>

            <p className="text-lg md:text-xl text-slate-300 mb-2 mt-6" data-id="element-118">
              Si no es para tu familia:
            </p>

            <p className="text-2xl md:text-3xl font-extrabold text-white mb-2 mt-4" data-id="element-119">
              devolución 100%
            </p>

            <p className="text-blue-300 font-medium italic text-lg mb-10" data-id="element-120">
              Sin preguntas. Sin riesgo.
            </p>

            <div className="inline-block bg-navy-950/80 px-8 py-3.5 rounded-full border border-navy-700 text-sm md:text-base font-medium text-slate-400" data-id="element-121">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}